// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"281":"baf048d9","829":"baf048d9"}[chunkId] + ".chunk.css";
};